import { httpProxy } from "../api";

export interface UpgradeTransitionStatus {
  status: string | null;
  transitionAt: string | null;
  lastAnalysisAt: string | null;
}

export interface WelcomeAnalysisResponse {
  message: string;
  brandId: number;
  status: string;
}

export interface WelcomeAnalysisStatus {
  brandId: number;
  status: string | null;
  completedAt: string | null;
}

/**
 * Get the current upgrade transition status for the logged-in user
 */
export async function getUpgradeTransitionStatus(): Promise<UpgradeTransitionStatus> {
  const response = await httpProxy.get("/user/upgrade-transition-status");
  return response.data;
}

/**
 * Trigger welcome analysis for the current brand
 * This can only be called once per user (when status is 'pending')
 */
export async function triggerWelcomeAnalysis(brandId: number): Promise<WelcomeAnalysisResponse> {
  const response = await httpProxy.post(`/brand/${brandId}/trigger-welcome-analysis`);
  return response.data;
}

/**
 * Get the status of the welcome analysis for a specific brand
 */
export async function getWelcomeAnalysisStatus(brandId: number): Promise<WelcomeAnalysisStatus> {
  const response = await httpProxy.get(`/brand/${brandId}/welcome-analysis-status`);
  return response.data;
}

const welcomeAnalysis = {
  getUpgradeTransitionStatus,
  triggerWelcomeAnalysis,
  getWelcomeAnalysisStatus
};

export default welcomeAnalysis;
